import { Rarity } from '#src/__generated__/globalTypes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useIsSpecialCardSet } from '#src/set/index.ts';

export const useHasLegacyEssence = () => {
  const isSpecialCardSet = useIsSpecialCardSet();
  const { currentUser } = useCurrentUserContext();

  const commonCardShardsChests =
    currentUser?.cardShardsChests?.filter(
      chest => chest.rarity === Rarity.common
    ) || [];
  return commonCardShardsChests.some(
    chest => !isSpecialCardSet(chest.cardSet?.slug) && chest.cardShardsCount > 0
  );
};
